<template>
  <el-dialog
    title="选择员工"
    :visible.sync="isShow"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    @open="clear"
  >
    <el-row>
      <el-col :span="12" style="border-right: 1px solid #D8DCE1;">
        <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }">
          <el-input
            clearable
            class="filter-input"
            placeholder="搜索员工"
            v-model="filterText"
            @input="dfhuh"
            size="small"
          >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div v-if="treeData01.length > 0 && treeData02.length === 0">
          <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              :check-strictly="true"
              :default-checked-keys="peoples"
              lazy
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node}">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;margin-left: 3px;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    <span style="margin-left: 3px;">{{ data.label }}</span>
                    <span
                      v-if="node.checked"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
        </el-card>
      </el-col>
      <el-col :span="12" style="border-right: 1px solid #D8DCE1;">
        <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }">
          <div>已选择的员工</div>
          <ul class="infinite-list" v-if="checkedEmployee.length">
            <li class="cich fsdfs" v-for="item in checkedEmployee" :key="item.id">
              <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
              <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
              <div class="uiwe">
                <i class="el-icon-close" @click="employeeClose(item)"></i>
              </div>
            </li>
          </ul>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <div></div>
      <div>
        <el-button type="info" plain @click="$emit('check-user', checkedEmployee = [])">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled" @click="$emit('check-user', checkedEmployee)">
          确定
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { isAllowRefresh } from '@/utils/util'
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false
    },
    checkeds: {
      type: Array,
      required: true
    },
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      count: 20,
      searchName: '',
      department: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      tableData: [],
      userSelection: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      filterText: '',
      isAllowRefresh: isAllowRefresh(),
      treeData01: [],
      treeData02: [],
      checkedEmployee: [],
      checkedEmp: 0,
      resolve_had: '',
      disabled: true,
      shopShow: false,
      isShowGaoliang: false,
      peoples: []
    }
  },
  mounted() {
    if (this.checkeds) {
       this.checkeds.forEach(k => {
        this.peoples.push(k.user_id)
      })
      this.checkedEmployee = this.checkeds
    }
    this.sfhusi()
    this.treeData01 = []
  },
  watch: {
    isShow: function(newVal, oldVal) {
      if (!newVal) {
        this.checkedEmployee = []
      }
    },
    treeData01: function(newVal) {
    },
    treeData02: function(newVal) {
      if (newVal.length > 0) {
        this.shopShow = true
      } else {
        this.shopShow = false
      }
    },
    checkedEmployee(val) {
      if (val.length > 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.sfhusi()
      }
    }
  },
  methods: {
    currentChange(val) {
      this.currentPage = val
    },
    // 获取组织架构
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 3000)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.chooseNode = 0
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          res.return_data = [{ isDepartment: true }]
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    reset() {
      this.currentPage = 1
      this.searchName = ''
      this.departmentId = ''
    },
    getChecked(value, isCheck) {
      if (value.isDepartment === true && value.value) {
        const checkedEmployee = this.checkedEmployee
        if (isCheck === false) {
          checkedEmployee.forEach((item, i) => {
            if (item.id === value.value) {
              checkedEmployee.splice(i, 1)
            }
          })
          return false
        }
        checkedEmployee.forEach((item, i) => {
          if (item.id === value.value) {
            checkedEmployee.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedEmployee.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedEmployee.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedEmployee = checkedEmployee
      } else {
        return false
      }
    },
    employeeClose(value) {
      this.checkedEmployee.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedEmployee.splice(i, 1)
          } else {
            this.checkedEmployee.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
          this.parent_id = 0
          this.sfhusi()
          // this.loadNode()
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    clear() {
      this.filterText = ''
      this.treeData02 = []
      this.treeData01 = []
      this.checkedEmployee = []
      this.parent_id = 0
      this.sfhusi()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-card {
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}
.dialog-footer {
  display: flex;
  justify-content: space-between;
}
.el-form-item {
  margin-bottom: 0;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep.cich{
  display: flex;
  width: 100%;
  align-items: left;
  justify-content: left;
}
.fsdfs{
  margin-top: 10px;
}
::v-deep .el-dialog__body {
  padding: 0;
}
ul {
  margin-left: -2.5rem;
}
::v-deep .el-button--primary.is-disabled {
    opacity: 0.7;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  color: #204a9e;
  font-size: bold;
  font-size: 15px;
  font-weight: 600;
  background: none;
}
</style>
